@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.promocodes

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.ridepromocode.RidePromoCodeDto
import com.narbase.letsgo.web.models.RidePromoCodeIneligibilityReason

object GetActivePromoCodesEndpoint : EndPoint<GetActivePromoCodesEndpoint.Request, GetActivePromoCodesEndpoint.Response>() {
    class Request(
        val pickupLat: Double?,
        val pickupLng: Double?,
        val destLat: Double?,
        val destLng: Double?
    )

    class Response(
        val ridePromo: RidePromoCodeDto?,
        @Suppress("NON_EXPORTABLE_TYPE") val ridePromoCodeIneligibilityReason: DtoName<RidePromoCodeIneligibilityReason>? = null
    )
}
